import React from "react"
import { appStrings } from "../../common/strings/app_strings"

const {
    addAnother,
    or,
    addMany,
} = appStrings.addProject

const renderTextAreaOrAddAnother = (props) => {
    const { 
        addRow,
        toggleIsTextArea,
        isTextArea,
        addOneByOne, 
    } = props
    return !isTextArea ? (
        <div>
            <p>
                <span className="link-text" onClick={addRow}>
                    {addAnother}
                </span>
                {` ${or} `}
                <span className="link-text" onClick={toggleIsTextArea}>
                    {addMany}
                </span>
            </p>
        </div>
    ) : (
        <p>
            <span className="link-text" onClick={toggleIsTextArea}>
                {addOneByOne}
            </span>
        </p>
    )
}

const ToggleAddAnother = props => {
    const {
        addRow,
    } = props
    return (
        <div className="col-md-12 flex-items add-another-row">
            { window.innerWidth <= 760 ? (
                <p>
                    <span className="link-text" onClick={addRow}>
                        {addAnother}
                    </span>
                </p>
            ) :  (
                renderTextAreaOrAddAnother(props)
            )}
        </div>
    )
}

export default ToggleAddAnother



// WEBPACK FOOTER //
// ./src/components/onboarding/toggle_add_another.jsx